<template>
  <div class="footer">
   <div class="w_1180 flex">
     <div class="footer_logo" @click="$router.push('/index')">
        <img src="../assets/img/logo2.png" alt="">
     </div>
     <div class="flex footer_conter flex1 flex_between">
        <div @click="$router.push('/qudong')">趣动 WillGo</div>
        <div @click="$router.push('/qyserve')">企业服务</div>
        <div @click="$router.push('/case')">客户案例</div>
        <div @click="$router.push('/news')">新闻资讯</div>
        <div @click="$router.push('/about_us')">联系我们</div>
        <div @click="goback()">登录管理后台</div>

     </div>
     <div class="fonter_info">
        <div><img src="../assets/img/footer_icon1.png" alt="">010-5338-8762</div>
        <div><img src="../assets/img/footer_icon2.png" alt="">willgo@qudonghealth.com</div>
        <div><img src="../assets/img/footer_icon3.png" alt="">北京市朝阳区永安东里华彬中心11层</div>
        
     </div>
   </div>
   <div class="footer_text">
     <div>Copyright © Beijing QuDong Co., Ltd., All Rights Reserved 京ICP备2021011558号-1</div>
     <div>北京趣动科技有限公司版权所有</div>
   </div>
  </div>
</template>

<script>
export default {
  methods:{
       goback(){
        window.open('https://organization.qudonghealth.com/')
      }
  }
}
</script>

<style scoped>
.footer{
    width: 100%;
    height: 294px;
    background-color: rgba(37, 41, 46, 1);
    padding-top: 73px;
    box-sizing: border-box;
    font-family: PingFangSC-Regular, PingFang SC;
}

   .flex {
       display: flex;
       align-items: center;
       justify-content: center;
   }
   .flex-1,
   .flex1 {
       flex: 1;
   }
   .flex_between{
    justify-content: space-between;
   }
   .footer_conter{
    color: rgba(255, 255, 255, 1);
    font-size: 13px;
    margin: 0 75px 0 105px;
    align-items: flex-start;
    padding-top: 6px;
    cursor:pointer
   }
   .footer_logo img{
    height:54px ;
    display: block;
     cursor:pointer
   }
   .fonter_info{
     color: #FFFFFF;
     font-size: 12px;
     text-align: left;
    
   }
     .fonter_info div{
        margin-bottom: 25px;
     }
   .fonter_info img{
    display: inline-block;
    width:26px ;
    vertical-align: middle;
    margin-right: 10px;
   }
   .w_1180{
    width: 1180px;
    margin: 0 auto;
    align-items: start;
}
.footer_text{
    width: 1180px;
    margin: 0 auto;
    border-top: 0.5px solid rgba(255, 255, 255, 0.15);
    padding-top: 12px;
    height: 60px;
    text-align: center;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.5);
}
.footer_text div{
    margin-bottom: 10px;
    transform: scale(0.83);
    transform-origin: center;
}
</style>


// WEBPACK FOOTER //
// src/components/bottom.vue